export const siteInfo = {
  name: '国产久久久',
  fullName: '国产久久久·精选内容长效聚合平台',
  description: '国产久久久汇聚海量优质国产内容，长效稳定更新，为用户提供持久流畅的优质体验。无论您寻找经典还是最新资源，国产久久久都能满足您的长期需求，稳定可靠，值得收藏。',
  url: 'https://guochan999.com',
  email: 'contact@guochan999.com',
  phone: '400-888-9999',
  address: '北京市朝阳区国贸中心A座',
  founded: '2020',
  stats: {
    totalContent: '50,000+',
    dailyUpdates: '200+',
    activeUsers: '3,280,000+',
    satisfaction: '98.6%',
  },
  features: [
    { title: '海量内容库', description: '超过五万部精选国产内容，涵盖电影、电视剧、纪录片、综艺、动画等全品类', icon: 'ri-database-2-line' },
    { title: '长效稳定更新', description: '每日200+内容更新，确保用户始终能够获取最新、最热的优质资源', icon: 'ri-refresh-line' },
    { title: '高清流畅体验', description: '全平台支持4K超高清画质，智能CDN加速确保流畅播放不卡顿', icon: 'ri-4k-line' },
    { title: '精准智能推荐', description: '基于用户偏好的智能推荐算法，帮您快速发现感兴趣的内容', icon: 'ri-focus-3-line' },
    { title: '多端无缝衔接', description: '支持网页、手机、平板、电视等多终端访问，观看记录云端同步', icon: 'ri-device-line' },
    { title: '安全稳定可靠', description: '企业级数据安全保障，7×24小时技术支持，平台稳定运行有保障', icon: 'ri-shield-check-line' },
  ],
  testimonials: [
    { name: '张先生', role: '资深影迷', content: '国产久久久是我每天必刷的平台，内容更新快、画质好、分类清晰，找片子特别方便。用了两年多了，体验一直很稳定。', rating: 5 },
    { name: '李女士', role: '影视从业者', content: '作为行业从业者，国产久久久的内容聚合能力令我印象深刻。从经典到最新，一站式满足所有观看需求，是我工作的重要参考工具。', rating: 5 },
    { name: '王同学', role: '大学生', content: '同学们都在用国产久久久，资源全、更新快，热门内容第一时间就能看到。推荐算法也很准，经常能发现意外的好内容。', rating: 5 },
    { name: '赵女士', role: '家庭用户', content: '一家老小都能在国产久久久上找到喜欢的节目，高清画质在大屏电视上看特别舒服。客服响应也很快，有问必答。', rating: 5 },
  ],
  faqs: [
    { question: '国产久久久平台的内容更新频率是怎样的？', answer: '国产久久久平台每日更新200+优质国产内容，涵盖最新热播剧集、电影、综艺、纪录片等全品类。我们的编辑团队全天候跟踪内容动态，确保用户能够第一时间获取最新资讯和资源。' },
    { question: '平台上内容的画质最高支持什么标准？', answer: '国产久久久平台全面支持1080P全高清和4K超高清画质。高清精选频道更有HDR和杜比视界格式的内容可供选择，为用户提供极致的视觉享受。实际画质取决于用户设备和网络条件。' },
    { question: '如何找到我感兴趣的内容？', answer: '您可以通过首页分类导航、搜索功能以及智能推荐算法快速找到感兴趣的内容。平台提供最新热播、经典回顾、高清精选、热门合集、独家首发、口碑推荐六大分类频道，同时也支持按类型、年份、评分等维度筛选。' },
    { question: '国产久久久平台是否需要付费使用？', answer: '国产久久久平台提供免费和会员两种服务模式。免费用户可畅享海量内容，会员用户则享有更高画质、去广告、独家内容等增值权益。我们致力于让每一位用户都能找到适合自己的使用方式。' },
    { question: '如何在多个设备上同步观看记录？', answer: '注册国产久久久账号后，您的观看记录、收藏列表和个人偏好设置将自动云端同步。无论您切换到手机、平板还是电视端，都可以无缝继续上次的观看进度，实现多端一体化体验。' },
  ],
};